import { Box, MenuItem } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Fragment, useContext } from 'react';
import { Button, Card, CardHeader, Col, Container, Input, Row, Table } from 'reactstrap';
import DataNotFound from '../../DataNoteFound/DataNotFound';
import Breadcrumbs from '../../layout/breadcrumb';
import TableSkeleton from '../../loader/TableSkeleton';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import { MuiTabelStyle } from '../../utils/helper';
import { useNavigate } from 'react-router';
import { classes } from '../../data/layouts';
import { Edit, Plus } from 'react-feather';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';
import { Payment } from '@material-ui/icons';
import moment from 'moment';
const BillManagementItem = (props) => {
  const history = useNavigate();
  const defaultLayoutObj = classes.find((item) => Object.values(item).pop(1) === 'compact-wrapper');
  const layout = localStorage.getItem('layout') || Object.keys(defaultLayoutObj).pop();
  const { sorting, setPage, setPageSize, pageSize, page, record, AddModel, editHandle, reportData } = props;
  const { formvalue, filter, setFilter } = useContext(BillManagementContext);
  const { responseLoader } = useContext(OrganizationContext);

  const ClearAllhandler = () => {
    setFilter({
      mobile: '',
      phone: '',
      createdAt: ''
    });
  };

  const handleFilterChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  // -------------------------------
  // COLUMNS BASED ON NEW API
  // -------------------------------
  const defaultColumns = [
    {
      flex: 0.18,
      minWidth: 250,
      field: 'name',
      headerName: 'Name',
      renderCell: (params) => <span style={{ cursor: 'pointer' }}>{params.row?.name}</span> ?? '--'
    },
    {
      flex: 0.18,
      minWidth: 100,
      field: 'mobile',
      headerName: 'Mobile Number',
      renderCell: (params) => <span style={{ cursor: 'pointer' }}>{params.row?.phone}</span> ?? '--'
    },
    {
      flex: 0.15,
      minWidth: 50,
      field: 'Total Bills',
      headerName: 'Total Bills',
      renderCell: (params) => (params.row.totalBills ? params.row.totalBills : '--')
    },
    {
      flex: 0.15,
      minWidth: 100,
      field: 'totalBillAmount',
      headerName: 'Bill Amount',
      renderCell: (params) =>
        params.row.totalBillAmount
          ? new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(params.row.totalBillAmount)
          : '--'
    },
    {
      flex: 0.15,
      minWidth: 100,
      field: 'totalDueAmount',
      headerName: 'Bill Due Amount',
      renderCell: (params) =>
        params.row.totalDueAmount
          ? new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(params.row.totalDueAmount)
          : '--'
    },
    {
      flex: 0.15,
      minWidth: 100,
      field: 'address',
      headerName: 'Address',
      renderCell: (params) => (params.row.address ? params.row.address : '--')
    },
    {
      flex: 0.1,
      minWidth: 155,
      field: 'createdAt',
      headerName: 'Date',
      renderCell: (params) =>
        params.row.createdAt ? moment(params.row.createdAt).format('DD MMM YYYY, hh:mm A') : '--'
    },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      minWidth: 120,
      renderCell: (params) => (
        <div className="d-flex p-0 m-0">
          <MenuItem onClick={() => editHandle(params.row.vendorId)}>
            <Edit style={{ color: 'green' }} />
          </MenuItem>
          <MenuItem onClick={() => AddBillModel(params.row.vendorId)}>
            <Payment style={{ color: 'purple' }} />
          </MenuItem>
        </div>
      )
    }
  ];

  const AddBillModel = (vendorId) => {
    const url = `${process.env.PUBLIC_URL}/BillManagement/PaymentBill/${vendorId}/${layout}`;
    history(url);
  };

  return (
    <Fragment>
      <Breadcrumbs parent="Accommodation Booking" />

      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <h3>Bill Management</h3>
              </CardHeader>

              <div className="px-4 pt-3 pb-2">
                <Row>
                  <Col md="4">
                    <div className="p-3 border rounded shadow-sm text-center bg-light">
                      <h6 className="text-muted mb-2">Total Bill Amount</h6>
                      <h4 className="mb-0 text-primary">
                        {reportData?.totalBillAmount
                          ? new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 0
                            }).format(reportData.totalBillAmount)
                          : '₹ 0'}
                      </h4>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="p-3 border rounded shadow-sm text-center bg-light">
                      <h6 className="text-muted mb-2">Total Due Amount</h6>
                      <h4 className="mb-0 text-danger">
                        {reportData?.totalDueAmount
                          ? new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 0
                            }).format(reportData.totalDueAmount)
                          : '₹ 0'}
                      </h4>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="p-3 border rounded shadow-sm text-center bg-light">
                      <h6 className="text-muted mb-2">Total Paid Amount</h6>
                      <h4 className="mb-0 text-success">
                        {reportData?.totalPaidAmount
                          ? new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 0
                            }).format(reportData.totalPaidAmount)
                          : '₹ 0'}
                      </h4>
                    </div>
                  </Col>
                </Row>
              </div>

              <Table>
                <thead>
                  <tr>
                    <th>
                      <Row>
                        <Col md="2 mb-2">
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Search Name..."
                            value={filter.name}
                            onChange={(e) => handleFilterChange('name', e.target.value)}
                          />
                        </Col>
                        <Col md="2 mb-2">
                          <Input
                            type="number"
                            className="form-control"
                            placeholder="Search Mobile..."
                            value={filter.phone}
                            onChange={(e) => handleFilterChange('phone', e.target.value)}
                          />
                        </Col>
                        {/* Date Picker */}
                        <Col md="2 mb-2">
                          <Input
                            type="date"
                            className="form-control"
                            value={filter.createdAt}
                            onChange={(e) => handleFilterChange('createdAt', e.target.value)}
                          />
                        </Col>

                        <Col md="2 mb-2">
                          <Button color="secondary" onClick={ClearAllhandler}>
                            Clear All
                          </Button>
                        </Col>
                        <Col md="4 mb-2" className={'d-flex justify-content-end'}>
                          <Button color="primary" onClick={AddModel}>
                            <Plus />
                          </Button>
                        </Col>
                      </Row>
                    </th>
                  </tr>
                </thead>
              </Table>

              <Box
                sx={{
                  '& .even': { backgroundColor: '#f1f1f1' },
                  '& .odd': { backgroundColor: 'white' }
                }}
              >
                {responseLoader ? (
                  <TableSkeleton />
                ) : formvalue?.length ? (
                  <DataGrid
                    sx={MuiTabelStyle}
                    autoHeight
                    pagination
                    rows={formvalue}
                    rowCount={record}
                    pageSize={pageSize}
                    getRowId={(row) => row.vendorId || row.createdAt}
                    columns={defaultColumns}
                    page={page - 1}
                    rowsPerPageOptions={[7, 10, 25, 50]}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                    paginationMode="server"
                    disableSelectionOnClick
                    sortingMode="server"
                    onSortModelChange={sorting}
                    getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
                  />
                ) : (
                  <DataNotFound />
                )}
              </Box>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default BillManagementItem;
